<template>
    <div class="row">
        <div class="col-12">
            <table class="table table-bordered table-sm">
                <tbody>
                    <tr>
                        <th class="w-50">Tarih</th>
                        <td class="w-50 font-weight-bolder text-primary">
                            {{currentDate}}
                        </td>
                    </tr>
                    <tr>
                        <th class="w-50">Sürücü</th>
                        <td class="w-50">
                            {{$safe(value,'Driver.Employee.FirstName') &&  $safe(value,'Driver.Employee.LastName') ? [$safe(value,'Driver.Employee.FirstName'),$safe(value,'Driver.Employee.LastName')].join(' ') : $safe(value,"Driver.DriverFullName")}}
                        </td>
                    </tr>
                    <tr>
                        <th class="w-50">Dijital Ehliyet Numarası</th>
                        <td class="w-50">{{$safe(value,"Driver.DriverCardNumber")}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-12">
            <table class="table table-bordered table-sm">
                <tbody>
                    <tr>
                        <th class="w-50">Takograf</th>
                        <td class="w-50" :class="getColor(value.Day.Tachograph.AllNew.Type.Code)">{{value.Day.Tachograph.AllNew.Type.Code || "-"}}</td>
                    </tr>
                    <!-- <tr>
                        <th class="w-50">Seyir</th>
                        <td class="w-50" :class="getColor(value.Day.Seyir.Type.Code)">{{value.Day.Seyir.Type.Code || "-"}}</td>
                    </tr> -->
                    <tr>
                        <th class="w-50">Günlük</th>
                        <td class="w-50" :class="getColor(value.Day.DailyCheckStatus.Type.Code)">{{value.Day.DailyCheckStatus.Type.Code || "-"}}</td>
                    </tr>
                    <tr>
                        <th class="w-50">Maaşa Esas Puantaj</th>
                        <td class="w-50" :class="getColor(value.Day.Score.Type.Code)">{{value.Day.Score.Type.Code || "-"}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-12">
            <table class="table table-bordered table-sm">
                <tbody>
                    <tr>
                        <th class="w-70">Takograf Gece Çalışma Süresi</th>
                        <td class="w-30">{{$safe(value,'Day.Tachograph.AllNew.TachoNightWorkTime') || "-"}}</td>
                    </tr>
                    <tr>
                        <th class="w-70">Takograf Gündüz Çalışma Süresi</th>
                        <td class="w-30">{{$safe(value,'Day.Tachograph.AllNew.TachoDayWorkTime') || "-"}}</td>
                    </tr>
                    <tr>
                        <th class="w-70 text-secondary">Takograf Toplam Çalışma Süresi</th>
                            <td class="w-30 text-secondary">{{$safe(value,'Day.Tachograph.AllNew.OriginalTacho') || "-"}}</td>
                    </tr>
                </tbody>
            </table>
            <table class="table table-bordered table-sm">
                <tbody>
                    <tr>
                        <th class="w-70 text-secondary">Güne Eklenen Denkleştirme Süresi</th>
                        <td class="w-30 text-secondary">{{$safe(value,'Day.Tachograph.AllNew.DenklestirmedenGelenSaat') || "-"}}</td>
                    </tr>
                    <tr class>
                        <th :class="$safe(value,'Day.Tachograph.AllNew.Edited')==true?'w-50 text-danger p-0':'w-50 text-info'">
                            <div class="d-flex align-items-center">
                                <feather-icon v-if="$safe(value,'Day.Tachograph.AllNew.Edited')==true" class="text-danger m-50 d-block" icon="AlertCircleIcon" v-b-tooltip.noninteractive.hover.bottom="'“Çalışma Zamanı” değiştirildiği için “Takograf Toplam Çalışma Süresi”yle tutarsızlık görmektesiniz.'"></feather-icon> 
                                Çalışma Zamanı Sayılan Süre
                            </div>
                        </th>

                        <td :class="$safe(value,'Day.Tachograph.AllNew.Edited')==true?'w-50 text-danger':'w-50 text-info'">
                            <div class="d-flex align-items-center g-50">
                            <template v-if="$safe(value,'HTM') != null">{{$safe(value,'HTM') || "-"}}</template>
                            <template v-else-if="$safe(value,'GTM') != null">{{$safe(value,'GTM') || "-"}}</template>
                            <template v-else>{{$safe(value,'WorkedTimeNew') || "-"}}</template>
                            <button v-if="$safe(value,'Day.Tachograph.AllNew.Edited')==true" :disabled="value.Locked" v-b-tooltip.noninteractive.hover.bottom="'Değiştirilen veriyi sıfırla'" class="btn btn-xs btn-flat-danger btn-icon" v-on:click="resetPresave()">
                                <feather-icon v-if="value.Locked" icon="LockIcon"></feather-icon>
                                <feather-icon v-else icon="RotateCcwIcon"></feather-icon>
                            </button>
                        </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table class="table table-bordered table-sm">
                <tbody>
                    <tr>
                        <th class="w-70">Fazla Mesai</th>
                        <td class="w-30">
                            {{ $safe(value,'GTMFM') != null ? $safe(value,'GTMFM') : $safe(value,'Day.Tachograph.AllNew.FM')  }}
                        </td>
                    </tr>
                    <tr>
                        <th class="w-70">Hafta Tatili Mesaisi</th>
                        <td class="w-30">
                            {{ $safe(value,'HTM') != null ? $safe(value,'HTM') : "00:00:00"  }}
                        </td>
                    </tr>
                    <tr>
                        <th class="w-70">Genel Tatil Mesaisi</th>
                        <td class="w-30">
                            {{ $safe(value,'GTM') != null ? $safe(value,'GTM') : "00:00:00" }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-12 mb-1" >
            <label class="form-label">Durum</label>
            <select class="form-control" v-model="value.Day.Score.Type.Code" v-on:change="getEksikGun" :disabled="value.Locked">
                <option :value="null">Seçiniz</option>
                <option v-for="type in types" :key="type.Code" :value="type.Code">{{type.Name}}</option>
            </select>
        </div>
        <div class="col-12 mb-1" v-if="value.Day.Score.Type.Code == 'N'">
            <b-form-checkbox :disabled="value.IsGTM || value.Locked" class="mb-50" v-model="value.IsHTM">Hafta Tatili Mesaisi</b-form-checkbox>
            <b-form-checkbox :disabled="value.IsHTM || value.Locked" v-model="value.IsGTM">Genel Tatil Mesasi</b-form-checkbox>
        </div>
        <div class="col-12 mb-1" v-if="value.Day.Score.Type.Code == 'RT' && value.CanArife">
            <b-form-checkbox :disabled="value.Locked" class="mb-50" v-model="value.IsArife">Arife Günü</b-form-checkbox>
        </div>
        <div class="col-md-12 mb-1" v-if="(eksikGuns || []).length != 0">
            <label class="form-label">Eksik Gün</label>
            <v-select-list :options="eksikGuns" label="Name" append-to-body :disabled="((eksikGuns || []).length <= 1) || value.Locked" placeholder="Eksik Gün" v-model="eksikGun"></v-select-list>
        </div>
        <template v-if="value.Day.Score.Type.Code == 'N' || value.Day.Score.Type.Code == 'Y' /*|| value.Day.Score.Type.Code == 'H' || value.Day.Score.Type.Code == 'RT'*/">
            <div class="col-md-12 mb-1" v-if="value.IsHTM==true || value.IsGTM==true">
                <label class="form-label">Çalışma Zamanı (Denkleştirme Hariç)</label>
                <v-date-picker :disabled="value.Locked" v-model="value.Day.Tachograph.AllNew.OriginalTacho" type="time" with-seconds placeholder="Çalışma Süresi"></v-date-picker>
            </div>
            <div class="col-md-12 mb-1" v-else>
                <label class="form-label">Çalışma Zamanı (Denkleştirme Hariç)</label>
                <v-date-picker :disabled="value.Locked" v-model="value.Day.Tachograph.AllNew.N" type="time" with-seconds placeholder="Çalışma Süresi"></v-date-picker>
            </div>
            <!-- <div class="col-md-12 mb-1">
                <label class="form-label">Gece Çalışma Süresi</label>
                <v-date-picker v-model="value.NightWorkedTime" type="time" with-seconds placeholder="Gece Çalışma Süresi"></v-date-picker>
            </div> -->
            <!-- <div class="col-md-12 mb-1" v-if="value.Holiday && value.Day.Score.Type.Code == 'N'">
                <label class="form-label">Resmi Tatil Mesaisi</label>
                <v-date-picker v-model="value.GTM" type="time" with-seconds placeholder="Resmi Tatil Mesaisi"></v-date-picker>
            </div> -->
        </template>
        <template v-if="displayMode === 'utc_plus_3'">
            <div class="col-12 mt-1">
                <div class="alert alert-warning mb-0 py-50">
                    <div class="alert-body d-flex align-items-center">
                        <span class="material-icons-outlined mr-50" style="font-size:18px">schedule</span>
                        UTC+3 Gösterimi (01.03.2026 ve sonrası kayıtlar)
                    </div>
                </div>
            </div>
        </template>
        <template v-if="(svgs || []).length">
            <div :class="['col-12',i != 0 ? 'mt-1' :'']" v-for="(svg,i) in svgs" :key="i">
                <div :class="['border p-50 rounded',i == 1 ? 'border-secondary' : null]">
                    <label :class="['form-label font-weight-bolder px-50 d-flex align-items-center',i==1 ? 'text-secondary' : null]">
                        <span v-if="i == 1" class="material-icons-outlined mr-25 current-date">star</span>
                        {{ svg.Day }}
                    </label>
                    <TachographSvg v-if="(svg.DailyTachographJsonModels || []).length > 0" :json="svg.DailyTachographJsonModels"/>
                    <template v-else>
                        <div class="alert alert-secondary mb-0">
                            <div class="alert-body">Personelin bu gün ({{ svg.Day }}) için takograf verisi yoktur.</div>
                        </div>
                    </template>
                </div>
            </div>
        </template>
        <template v-if="hasSvgError">
            <div class="col-12 mt-1">
                <div class="alert alert-danger mb-0">
                    <div class="alert-body">Personelin ehliyet bilgisi, dijital ehliyet bilgisi yok ya da takograf ile eşleşmiyor.</div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import EmployeeOperationApi from '@/api/employee-operations'
import moment from 'moment'
import TachographSvg from './TachographSvg.vue';
import { BCollapse, BFormCheckbox, VBTooltip } from 'bootstrap-vue';
import HumanResourcesParametersApi from '@/api/human-resources-parameters';

export default {
    components:{
        TachographSvg,
        BCollapse,
        BFormCheckbox
    },
    props:{
        value:Object,
        types:{
            type:Array,
            default:()=>[]
        },
        displayMode:{
            type:String,
            default:'utc'
        }
    },
    directives:{
        'b-tooltip':VBTooltip
    },
    data(){
        return {
            eksikGuns:[],
            svgs:[],
            hasSvgError:false,
        }
    },
    watch:{
        "value.Day.Score.Type.Code"(){
            this.value.GTM = null
            //this.value.SGKEksikGunId = null
            this.value.IsGTM = false
            this.value.IsHTM = false
            this.value.IsArife = false
        },
        "value.IsGTM"(){
            this.value.IsHTM = false
        },
        "value.IsHTM"(){
            this.value.IsGTM = false
        }
    },
    mounted(){
        this.getEksikGun()
        this.getTachoSvgs()
    },
    methods:{
        getTachoSvgs(){
            EmployeeOperationApi.Tachograph.TachographJSONThreeDay(this.value.Employee.Employee.Id, moment(this.value.Day.Date,'DD.MM.YYYY').format('YYYY-MM-DD'), this.displayMode).then(res => {
                if(res.data.Success){
                    this.svgs = res.data.Data
                }else { this.hasSvgError = true }
            })
        },
        getColor(type){
            let color = this.types.find(t=> t.Code == type)?.Color || null
            return color ? `type-${color}` : null
        },
        resetPresave(){
            this.$confirm("Emin misiniz?",`Bu işlem, ${this.value.Day.Date} tarihi için sonradan girilen çalışma zamanını silecek ve varsayılan olarak orijinal takograf verisini baz alacaktır. Devam etmek istiyor musunuz?`)
            .then(result=>{
                if(result){
                    var employeeId = this.value.Employee.Employee.Id
                    var day = this.value.Day.Date?moment(this.value.Day.Date,'DD.MM.YYYY').format('YYYY-MM-DD'):null
                    var res = EmployeeOperationApi.Score.ResetPresave({
                        EmployeeId:employeeId,
                        Date:day,
                        Driver:true,
                        Month:moment(this.value.Day.Date,'DD.MM.YYYY').month(),
                        Year:moment(this.value.Day.Date,'DD.MM.YYYY').year(),
                        BranchId:this.value?.BranchId || null
                    })
                    res.then(r=>{
                        this.$result(r)
                        this.$emit('refresh')
                    })
                }
            })
        },
        getEksikGun(){
            if(this.value.Day.Score.Type.Code){
                this.value.SGKEksikGunId = null
                HumanResourcesParametersApi.SGKEksikGun.ListByWorkingType(this.value.Day.Score.Type.Code).then(res => {
                    this.$set(this,'eksikGuns',(res.data.Data || []).map(e=>({
                    ...e,
                    Name:`${e.Code} - ${e.Name}`
                    })).sort((a,b)=> a.Code - b.Code))
                    if(this.eksikGuns.length == 1){
                        this.eksikGun = this.eksikGuns[0]
                    }
                })
                // const type = this.types.find(t=> t.Code == this.value.Day.Score.Type.Code) || null
                // if(type){
                //     const code = type.TIP +""+ type.SIRA_NO
                //     EmployeeOperationApi.Score.EksikGunByKykm(code).then(res=>{
                //         this.eksikGuns = (res.data.Data || []).map(e=>({
                //     ...e,
                //     Name:`${e.GRUP_KOD} - ${e.GRUP_ISIM}`
                //     })).sort((a,b)=> Number(a.GRUP_KOD) - Number(b.GRUP_KOD))
                //         if(this.eksikGuns.length == 1){
                //             this.eksikGun = this.eksikGuns[0]
                //         }
                //     })
                // }
            }
        }
    },
    computed:{
        currentDate(){
            return this.value?.Day?.Date ? moment(this.value.Day.Date,'DD.MM.YYYY').locale('tr').format('DD.MM.YYYY dddd') : "-" 
        },
        eksikGun:{
            get:function(){
                return this.eksikGuns.find(s=>s.Id==this.value.SGKEksikGunId)
            },
            set:function(value){
                this.value.SGKEksikGunId = value?.Id || null
            }
        }
    },
    
}
</script>

<style>
.current-date{
    font-size: 0.95rem;
}
</style>